var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMother(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.49674 0.4646V3.75407H0.500977V10.453H2.49674V12.3078H0.500977V15.7118H2.49674V29.5353H30V0.4646H2.49674ZM1.27741 4.52871H4.4925V9.67295H1.27741V4.52871ZM1.27741 13.0824H4.4925V14.9372H1.27741V13.0824ZM3.27317 28.7552V15.7118H5.26894V12.3078H3.27317V10.453H5.26894V3.75407H3.27317V1.23924H29.2236V10.333H25.5984V17.032H29.2236V19.5359H26.9161V23.6H29.2236V28.7606H3.27317V28.7552ZM29.2236 11.1077V16.2519H26.3748V11.1077H29.2236ZM29.2236 20.3106V22.8254H27.6926V20.3106H29.2236Z",
    fill: "#1C1C1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7855 3.75415H18.009V13.6826H18.7855V3.75415Z",
    fill: "#1C1C1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7703 3.75415H19.9939V13.6826H20.7703V3.75415Z",
    fill: "#1C1C1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7496 3.75415H21.9731V13.6826H22.7496V3.75415Z",
    fill: "#1C1C1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4944 19.5305H7.11157V20.3052H16.4944V19.5305Z",
    fill: "#1C1C1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4944 21.5161H7.11157V22.2908H16.4944V21.5161Z",
    fill: "#1C1C1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4944 23.502H7.11157V24.2766H16.4944V23.502Z",
    fill: "#1C1C1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4944 25.4878H7.11157V26.2624H16.4944V25.4878Z",
    fill: "#1C1C1C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7051 20.8345C20.5623 20.8345 19.6328 21.7619 19.6328 22.902C19.6328 24.0421 20.5623 24.9695 21.7051 24.9695C22.8479 24.9695 23.7774 24.0421 23.7774 22.902C23.772 21.7619 22.8479 20.8345 21.7051 20.8345ZM21.7051 24.1894C20.9943 24.1894 20.4092 23.6112 20.4092 22.8965C20.4092 22.1874 20.9888 21.6037 21.7051 21.6037C22.4214 21.6037 23.001 22.1819 23.001 22.8965C22.9955 23.6112 22.4159 24.1894 21.7051 24.1894Z",
    fill: "#1C1C1C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1602 3.75415H8.45117V10.4531H15.1657V3.75415H15.1602ZM14.3838 9.67848H9.22761V4.52879H14.3838V9.67848Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMother);
export default __webpack_public_path__ + "static/media/mother.3f5ae3633296bc9cb13698f2016501df.svg";
export { ForwardRef as ReactComponent };